import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const ZipIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 32 32"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <path
        d="M20.0231 2.875C20.2147 2.87447 20.4045 2.91196 20.5815 2.98529C20.7586 3.05861 20.9193 3.16633 21.0544 3.30219L26.6875 8.93531C26.8233 9.07043 26.931 9.23114 27.0044 9.40815C27.0777 9.58517 27.1152 9.77496 27.1147 9.96656V27.6666C27.1147 28.4709 26.4538 29.125 25.6416 29.125H6.34812C5.53562 29.125 4.875 28.4709 4.875 27.6666V4.33344C4.875 3.52906 5.53594 2.875 6.34812 2.875H20.0231ZM20.0231 2H6.34812C5.05125 2 4 3.04469 4 4.33344V27.6666C4 28.9553 5.05125 30 6.34812 30H25.6416C26.9384 30 27.9897 28.9553 27.9897 27.6666V9.96656C27.9896 9.34771 27.7438 8.75421 27.3062 8.31656L21.6731 2.68344C21.2355 2.24592 20.642 2.0001 20.0231 2Z"
        fill="currentColor"
      />
      <path
        d="M20 2V7.33344C20.0001 8.04063 20.281 8.71883 20.7811 9.21889C21.2812 9.71895 21.9594 9.99992 22.6666 10H28L20 2Z"
        fill="currentColor"
      />
      <path
        d="M17.6587 26V21.9272H19.2655C19.5744 21.9272 19.8376 21.9862 20.055 22.1042C20.2724 22.2209 20.4381 22.3833 20.5522 22.5915C20.6675 22.7983 20.7252 23.0369 20.7252 23.3074C20.7252 23.5778 20.6668 23.8165 20.5502 24.0233C20.4335 24.2301 20.2645 24.3912 20.0431 24.5065C19.823 24.6218 19.5565 24.6795 19.2436 24.6795H18.2195V23.9895H19.1044C19.2701 23.9895 19.4067 23.961 19.5141 23.904C19.6228 23.8456 19.7037 23.7654 19.7567 23.6633C19.8111 23.5599 19.8382 23.4413 19.8382 23.3074C19.8382 23.1721 19.8111 23.0541 19.7567 22.9534C19.7037 22.8513 19.6228 22.7724 19.5141 22.7167C19.4054 22.6597 19.2675 22.6312 19.1005 22.6312H18.5198V26H17.6587Z"
        fill="currentColor"
      />
      <path
        d="M16.9502 21.9272V26H16.0891V21.9272H16.9502Z"
        fill="currentColor"
      />
      <path
        d="M12.3103 26V25.4889L14.3426 22.6372H12.3063V21.9272H15.4245V22.4383L13.3901 25.29H15.4284V26H12.3103Z"
        fill="currentColor"
      />
      <path d="M17.7432 2H15.7615V3.98165H17.7432V2Z" fill="currentColor" />
      <path
        d="M15.7615 3.98169H13.7798V5.96334H15.7615V3.98169Z"
        fill="currentColor"
      />
      <path
        d="M17.7432 5.96332H15.7615V7.94497H17.7432V5.96332Z"
        fill="currentColor"
      />
      <path
        d="M15.7615 7.94495H13.7798V9.9266H15.7615V7.94495Z"
        fill="currentColor"
      />
      <path
        d="M17.7432 9.92657H15.7615V11.9082H17.7432V9.92657Z"
        fill="currentColor"
      />
      <path
        d="M15.7615 11.9082H13.7798V13.8899H15.7615V11.9082Z"
        fill="currentColor"
      />
      <path
        d="M17.7432 14.3853H13.7799V20H17.7432V14.3853Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default memo(ZipIcon);
